import { outter_post_newUrl, outter_post, post } from 'common/js/axios-helper';
import { prairies } from "./constant/UrlMapper";

const host = '8885';
const host2 = '8883';
const host3 = '8880';
const host4 = '8889';

const prairiesList = (data) => {
    return post(prairies.prairiesList, data, host);
}
const addPrairies = (data) => {
    return post(prairies.addPrairies, data, host);
}
const openAddprairies = (data) => {
    return post(prairies.openAddprairies, data, host);
}
const signList = (data) => {
    return post(prairies.signList, data, host);
}
const signListThree = (data) => {
    return post(prairies.signListThree, data, host);
}
const signListFour = (data) => {
    return post(prairies.signListFour, data, host);
}
const aqfbyhglList = (data) => {
    return post(prairies.aqfbyhglList, data, host2);
}
const signLiuliang = (data) => {
    return post(prairies.signLiuliang, data, host);
}
const editData = (data) => {
    return post(prairies.editData, data, host);
}
export default {
    prairiesList,
    addPrairies,
    openAddprairies,
    signList,
    signListThree,
    signListFour,
    aqfbyhglList,
    signLiuliang,
    editData

}



// WEBPACK FOOTER //
// ./src/service/Prairies.js